import React from "react";
import { getClassName } from "@sscs/utils";
import styles from "./countChip.module.scss";
const CountChip = React.forwardRef(({ children, className, ...rest }, ref) => (React.createElement("span", { ref: ref, className: getClassName(styles.chip, className), ...rest }, children)));
CountChip.displayName = "CountChip";
export default CountChip;
//# sourceMappingURL=CountChip.js.map